import { fork } from "redux-saga/effects";
import { saga as beachSaga } from "./beach";
import { saga as citySaga } from "./city";
import { saga as holderSaga } from "./holder";
import { saga as officerSaga } from "./officer";

export default function* rootSaga() {
  yield fork(holderSaga);
  yield fork(officerSaga);
  yield fork(citySaga);
  yield fork(beachSaga);
}
